// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__18PaV","header":"MergedInvoice_header__3ZM5i"};